var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1386 35.1114H7.75436C6.47981 35.1114 5.4412 34.0095 5.4412 32.6518V8.67108L22.5586 22.3217C22.9703 22.6512 23.4584 22.8136 23.9465 22.8136C24.4346 22.8136 24.9227 22.6512 25.3344 22.3217L42.4518 8.67108V32.6518C42.4518 34.0095 41.4132 35.1114 40.1386 35.1114ZM38.5957 5.5971L23.9465 17.28L9.29723 5.5971H38.5957ZM40.1392 0.679688H7.75492C3.92895 0.679688 0.81543 3.99026 0.81543 8.05838V32.654C0.81543 36.7222 3.92895 40.0327 7.75492 40.0327H40.1392C43.9652 40.0327 47.0787 36.7222 47.0787 32.654V8.05838C47.0787 3.99026 43.9652 0.679688 40.1392 0.679688Z",
    fill: "#009999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e4d2a6c734a98fba864c07df80a2525b.svg";
export { ForwardRef as ReactComponent };